import { render, staticRenderFns } from "./schoolDetail.vue?vue&type=template&id=5bb775b9"
import script from "./schoolDetail.vue?vue&type=script&lang=js"
export * from "./schoolDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports